import { registerComponent } from "helpers";

registerComponent(
  "filters-toggle",
  class FiltersToggle extends HTMLElement {
    constructor() {
      super();

      this.config = JSON.parse(this.querySelector("[data-config]").textContent);
      this.buttonText = document.querySelector(
        "[data-filters-toggle-button-text]",
      );
      this.collectionProducts = document.querySelector(".collection__products");
      this.searchProducts = document.querySelector(".search__main");
      this.addEventListener("click", this.onToggleClick.bind(this));
    }

    onToggleClick() {
      if (this.getAttribute("data-filters-toggle") === "visible") {
        if (this.isCollection()) {
          this.collectionProducts.classList.add(
            "collection__products--hide-filters",
          );
        } else {
          this.searchProducts.classList.add("search__main--hide-filters");
        }
        this.setAttribute("data-filters-toggle", "hidden");
        this.buttonText.textContent = this.config.showFilters;
      } else {
        if (this.isCollection()) {
          this.collectionProducts.classList.remove(
            "collection__products--hide-filters",
          );
        } else {
          this.searchProducts.classList.remove("search__main--hide-filters");
        }
        this.setAttribute("data-filters-toggle", "visible");
        this.buttonText.textContent = this.config.hideFilters;
      }
    }

    isCollection() {
      return document.querySelector(".collection");
    }
  },
);
